import type { PostHogConfig } from 'posthog-js';
import { filtrarExcecaoBeforeSend } from './posthog-before-send';
import { redactSensitiveProperties } from './posthog-properties';

export function buildPostHogConfig(args: {
  apiHost: string;
  sessionReplayEnabled: boolean;
  surveysEnabled: boolean;
  onLoaded: () => void;
}): Partial<PostHogConfig> {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  return {
    api_host: args.apiHost,
    autocapture: true,

    before_send: (cr) => filtrarExcecaoBeforeSend(cr, origin),
    capture_pageview: false,
    capture_pageleave: true,
    mask_all_text: true,
    respect_dnt: true,

    enable_recording_console_log: false,
    capture_performance: { network_timing: false, web_vitals: true },
    disable_session_recording: !args.sessionReplayEnabled,
    disable_surveys: !args.surveysEnabled,
    session_recording: {
      maskAllInputs: true,
      captureCanvas: { recordCanvas: false }
    },
    persistence: 'localStorage+cookie',
    cross_subdomain_cookie: false,

    sanitize_properties: (properties: Record<string, unknown>) => {
      try {
        const urlSanitized = sanitizarPropriedadesUrl(properties);
        return redactSensitiveProperties(urlSanitized) as Record<string, unknown>;
      } catch {
        return properties;
      }
    },
    loaded: () => args.onLoaded()
  };
}

export const URL_PROPERTY_KEYS: readonly string[] = [
  '$current_url',
  '$pathname',
  '$referrer',
  '$referring_domain',
  '$initial_current_url',
  '$initial_pathname',
  'path'
];

export function removerQueryDaUrl(valor: string): string {
  return valor.split('?')[0].split(';')[0];
}

export function sanitizarPropriedadesUrl(
  properties: Record<string, unknown>
): Record<string, unknown> {
  try {
    if (!properties || typeof properties !== 'object') {
      return properties;
    }
    const out: Record<string, unknown> = { ...properties };
    for (const key of URL_PROPERTY_KEYS) {
      const valor = out[key];
      if (typeof valor === 'string' && valor.length > 0) {
        out[key] = removerQueryDaUrl(valor);
      }
    }
    return out;
  } catch {

    return properties;
  }
}
